import { render, staticRenderFns } from "./DepositInformation.vue?vue&type=template&id=3c6f639c&scoped=true&"
import script from "./DepositInformation.vue?vue&type=script&lang=js&"
export * from "./DepositInformation.vue?vue&type=script&lang=js&"
import style0 from "./DepositInformation.vue?vue&type=style&index=0&id=3c6f639c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f639c",
  null
  
)

export default component.exports